<template>
  <div class="chuKuZuoyeWarp">
    <div class="chuKuZuoyeWarp-body">
        <div class="detailsTitle">
          <h4>冻结记录</h4>
           <div @click="back"><i class="fa fa-reply"></i></div>
        </div>
        <div class="inpBox" ref="searchBox">
          <el-form :inline="true" :model="searchFrom" class="demo-form-inline">
            <el-form-item label="货主名称:">
              <el-input v-model="searchFrom.customerName" size="mini" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="业务类型:" prop="invoiceType">
              <el-select v-model="searchFrom.invoiceType" placeholder="请选择" size="mini" >
                <el-option label="全部" value=""></el-option>
                  <el-option label="运输业务" value="1"></el-option>
                  <el-option label="快递业务" value="2"></el-option>
                  <el-option label="找车业务" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务单号:">
              <el-input v-model="searchFrom.transSerialno" size="mini" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="交易类型:">
              <el-select v-model="searchFrom.extertransType" placeholder="请选择" size="mini" >
                <el-option label="冻结" value="6" ></el-option>
                <el-option label="解冻" value="7" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发生时间:">
              <el-date-picker
                v-model="searchFrom.startTime"
                size="mini"
                style="width:195px"
                placeholder="选择日期"
                type="date"
                value-format="yyyy-MM-dd"
              ></el-date-picker>&nbsp;-&nbsp;
              <el-date-picker
                v-model="searchFrom.endTime"
                size="mini"
                style="width:195px"
                placeholder="选择日期"
                type="date"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-button  type="primary" size="mini" @click="search" >查询</el-button>
              <el-button  type="primary" size="mini" @click="chongZhi" >重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!--  表格 -->
    <div class="tiHuoDanGuanLiWarp-body-table" :style="{height:h}">
      <el-table
        :data="tableList"
        ref="tableList"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="customerName"   label="货主名称" align="center"  ></el-table-column>
        <el-table-column property="invoiceType" label="业务类型">
          <template scope="scope">{{["运输业务", "快递业务", "找车业务"][scope.row.invoiceType-1]}}</template>
        </el-table-column>
        <el-table-column prop="transSerialno"   label="业务单号" align="center"  ></el-table-column>
        <!-- <el-table-column prop=""   label="账户" align="center"  ></el-table-column> -->
        <el-table-column prop="extertransType"  label="交易类型"  align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>
            <span v-if="scope.row.extertransType == '6'">冻结</span>
            <span v-if="scope.row.extertransType == '7'">解冻</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="transMoney"    label="金额"  align="center"  ></el-table-column>
        <el-table-column property="transTime" label="发生时间"  align="center" :formatter="dateTimeFormat" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div style="text-align: left;">
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[1,10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    </div>
  </div>
</template>
<script>
import { dateTimeFormat } from '@/utils/util'
import {
  getPayList // 列表
} from '@/api/consignment'
export default {
  name: 'carriage',
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      isDisableDaochu: false,
      h: '500px',
      tableList: [],
      searchFrom: {
        pageSize: 10,
        pageNo: 1,
        accountType: 1,
        startTime: '',
        endTime: '',
        extertransTypes: [6, 7],
        extertransType: ''
      },
      total: 0
    }
  },
  created () {
    this.getListData()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 150 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 列表数据
    getListData () {
      getPayList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        console.log(err.message)
      })
    },
    // 点击查询
    search () {
      this.getListData()
    },
    // 表格分页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getListData()
    },
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getListData()
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 点击重置
    chongZhi () {
      this.searchFrom = {
        pageSize: 10,
        pageNo: 1,
        accountType: 1,
        startTime: '',
        endTime: '',
        extertransTypes: [6, 7],
        extertransType: ''
      }
      this.getListData()
    }
  }
}
</script>
<style lang="scss" scoped>
.top{
  width:98%;
  height:100px;
  border:solid 1px #ccc;
  margin: 0 auto;
  display: flex;
  .icon{
    width: 21px;
    height: 21px;
    // background: url('../../../assets/images/wenhao.png');
    img{
      width: 100%;
    }
  }
  .font{
    cursor: pointer;
    color:#409EFF;
    margin-left:40px;
  }
  .el-dropdown-link{
    display: block;
    // margin-top: -5px;
  }
  .font2{
    cursor: pointer;
    color:#409EFF;
    margin-left:40px;
  }
  .img{
      width: 15px;
      height: 15px;
  }
  .top_right{
    margin-left: 10%;
    margin-top:35px;
  }
}
.my-dropdown {
      float: right;
      .avatar {
        width: 30px;
        height: 30px;
        vertical-align: middle;
        display: inline-block;
      }
      .username {
        color: #fff;
        vertical-align: middle;
        font-size: 12px;
        margin-left: 4px;
      }
    }
.box1B {
  margin-left: 95px !important;

  display: flex !important;
  flex-wrap: wrap !important;
  span {
    // margin-left: 20px !important;
    line-height: 26px !important;
  }
}
.addressBoxTitle {
  div {
    font-size: 22px;
    font-style: 700;
    float: left;
    margin-right: 80px;
  }
}
.addressBoxImg {
  .ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 150px;
      height: 150px;
      border-radius: 20px;
      overflow: hidden;
      border: 1px dashed #ccc;
      margin-right: 30px;
      text-align: center;

      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .ul2 {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 150px;
      margin-right: 30px;

      text-align: center;
    }
  }
}
/deep/.inpBox .el-input__inner {
  width: 195px !important;
}
// .inpBox .el-date-editor{
//     width: 260px!important;
//  }
 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
    margin-top: 10px;
  }
}
.el-form-item {
  margin-left: 10px;
}
.huoQuanChangeWarp-body-title {
  width: 100%;
  height: 35px;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  box-sizing: border-box;
  span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #2f2f2f;
    display: inline;
    line-height: 30px;
    // margin-left: 20px;
  }
}
.chuKuZuoyeWarp {
  width: 100%;
  position: relative;
  height: 100%;
  .pags {
    width: 100%;
    text-align: center;
  }
  // border: solid 1px blue;
  .chuKuZuoyeWarp-body {
    width: 100%;
    position: absolute;

    .chuKuZuoyeWarp-body-queryIpt {
      // margin-top: 5px;
      width: 100%;

      // border: solid 1px;
      display: flex;
      ul {
        flex: 1;
        flex-direction: column;
        display: flex;
        li {
          margin-top: 5px;
          list-style: none;
        }
      }
    }

    .chuKuZuoyeWarp-body-btn {
      margin-top: 5px;
    }
    .chuKuZuoyeWarp-body-table {
      margin-top: 5px;
    }
  }
  /deep/ .el-textarea .el-textarea__inner {
    resize: none;
  }
}
</style>
